/**
 * Axios Interceptor
 * @param {*} instance
 */
import { reloadTab } from "utils";
import { getAccessToken } from "./index";
import { AUTH_TOKEN_KEY, ORGANIZATION_ID, STATUS_CODES } from "utils/constants";
import { appClearStorage, getItemFromStorage } from "utils/storage";

let store;
export const injectStore = (_store) => {
  store = _store;
};

export const interceptor = (instance) => {
  // request interceptor
  instance.interceptors.request.use(
    function (config) {
      config.headers = config.headers || {};
      const token = getItemFromStorage(AUTH_TOKEN_KEY);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (ORGANIZATION_ID && !config.headers["x-organization-id"]) {
        config.headers["x-organization-id"] = ORGANIZATION_ID;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // response interceptor
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (
        error?.response?.data?.code === "token_not_valid" ||
        (store.getState().layout.isUserIdle &&
          error?.response?.status === STATUS_CODES.UNAUTHORIZED)
      ) {
        /**
         * When user is Idle & Access token is expired
         * Clear everything & Logout
         * */
        appClearStorage();
        reloadTab();
        return Promise.reject(null);
      } else if (
        !store.getState().layout.isUserIdle &&
        error?.response?.status === STATUS_CODES.UNAUTHORIZED
      ) {
        /**
         * When user is not Idle & Access token is expired
         * Fetch & set new access token
         * */
        getAccessToken();
      }
      return Promise.reject(error);
    }
  );
};
